var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSmallThumbnailsViewIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  fill: "none"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.6 9.9v4.2c0 .336.264.6.6.6h3.6c.336 0 .6-.264.6-.6V9.9c0-.336-.264-.6-.6-.6h-3.6c-.336 0-.6.264-.6.6Zm-6 4.2V9.9c0-.336.264-.6.6-.6h3.6c.336 0 .6.264.6.6v4.2c0 .336-.264.6-.6.6h-3.6a.594.594 0 0 1-.6-.6ZM7.8 9.3H4.2c-.336 0-.6.264-.6.6v4.2c0 .336.264.6.6.6h3.6c.336 0 .6-.264.6-.6V9.9c0-.336-.264-.6-.6-.6Z",
  fill: "currentColor",
  fillRule: "evenodd"
}))));
export default SvgSmallThumbnailsViewIcon;